import {REST_METHODS} from '@/src/app/constants/api';
import {getAuthorizationToken} from '@/src/app/utils/authorizationToken';
import authorizedFetch from '@/src/app/utils/authorizedFetch';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

const fetchClinicsForFilter = () => {
  const method = getAuthorizationToken() ? authorizedFetch : unauthorizedFetch;

  // @ts-ignore
  return method({
    method: REST_METHODS.GET,
    path: '/api/v1/job_portal/vacancies_filters/clinics',
  });
};

export default fetchClinicsForFilter;
